/** Legacy Alert component + AlertService subscription id for product-created banner on summary. */
export const PRODUCT_SUMMARY_CREATED_ALERT_ID = "PRODUCT_SUMMARY_CREATED";

/** Banner on product summary after visibility is changed from the edit drawer. */
export const PRODUCT_SUMMARY_VISIBILITY_ALERT_ID = "PRODUCT_SUMMARY_VISIBILITY_UPDATED";

/** Maps persisted visibility values to user-facing labels (aligned with Product Visibility form). */
export function formatProductVisibilityLabel(visibility: string | undefined): string {
  const v = (visibility ?? "").toLowerCase().trim();
  const labels: Record<string, string> = {
    team: "My Team",
    account: "My Account",
    organization: "Organization",
    public: "Public",
  };
  if (labels[v]) return labels[v];
  if (!visibility?.trim()) return "";
  return visibility.charAt(0).toUpperCase() + visibility.slice(1).toLowerCase();
}
